
window.URL_ASSETS_BASE = 'https://www.sprinta.com.br/'
window.URL_BASE_OLD = 'https://www.sprinta.com.br/'
window.LOGIN_SCREEN = 'https://app.sprinta.com.br/login'

window.EVENT_PUBLISHED_URL = 'https://app.sprinta.com.br/event/'
window.PANEL_LINK = 'https://sprinta.com.br/dash/home/dashboard/view/'

window.gmak = "AIzaSyBs35Y5zZ1bip8CEPeu6cLX2pQ2efHGaZo"

window.URL_API = 'https://api.sprinta.com.br/'
window.URL_EVENT_SERVICE = 'https://api.sprinta.com.br/event_service/'
window.URL_EXPERIENCE_SERVICE = 'https://api.sprinta.com.br/experience_service/'


// WEBPACK FOOTER //
// ./src/_config.js